import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import Calendar from 'hydrateio-react-calendar-pane'
import moment from 'moment'

import { Icon } from '../../../../shared/tr-icons'
import {
  DateRangeWrapper,
  DateRangeOuter,
  DateRangeCalendar,
  TodayLink,
  DateRangeLabel,
  DateRangeDescription,
  ErrorDivWrapper
} from '../StyledComponents'

export default class DateSingleComponent extends Component {
  constructor(props) {
    super(props)

    // Devnote: set position to be 'below' here to switch on window location sensitive positioning
    this.state = {
      position: 'below',
      fromDateClicked: 'true',
      date: this.props.date
        ? this.getMomentDate(this.props.date, true).isValid()
          ? moment(this.props.date).format(this.props.dateFormat ? this.props.dateFormat.toUpperCase() : 'DD/MM/YYYY')
          : this.props.date
        : '',
      errors: this.props.date
        ? this.getMomentDate(this.props.date, true).isValid()
          ? {}
          : {message: this.props.i18n.invalid_date}
        : {}
    }

    this.onSelect = this.onSelect.bind(this)
    this.handleClickOutsideDate = this.handleClickOutsideDate.bind(this)
    this.selectToday = this.selectToday.bind(this)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutsideDate)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutsideDate)
  }

  componentWillReceiveProps(newProps) {
    const { dateFormat } = this.props

    if (newProps.date === null) {
      this.initialiseErrors()
    }

    this.setState({
      date: newProps.date
        ? this.getMomentDate(newProps.date, true).isValid()
          ? moment(newProps.date).format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')
          : newProps.date
        : '',
      errors: newProps.date
        ? this.getMomentDate(newProps.date, true).isValid()
          ? this.getMomentDate(newProps.date).isAfter(moment())
            ? newProps.preventFutureDates
              ? {message: newProps.i18n.invalid_future_date}
              : {}
            : {}
          : {message: newProps.i18n.invalid_date}
        : {}
    })
  }

  selectToday = event => {
    event.stopPropagation()
    event.preventDefault()
    this.onSelect(moment())
  }

  onSelect(date) {
    const { dateFormat, dateSingleCallBack, handleDateChange } = this.props

    const selectedDate = this.getMomentDate(date)
    const errors = {}

    if (!Object.keys(errors).length > 0) {
      if (dateSingleCallBack && window.TR_pageFunctions[dateSingleCallBack]) {
        window.TR_pageFunctions[dateSingleCallBack](date.toDate())
      }
      this.setState({
        show: false,
        date: selectedDate.format(
          dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY'
        )
      })

      if (handleDateChange) {
        handleDateChange(this.getMomentDate(date).toDate())
      }
    } else {
      this.setState({ errors })
      if (handleDateChange) {
        handleDateChange(date, this.state.errors)
      }
    }
  }

  initialiseErrors = event => {
    const state = this.state

    state.errors = {}
    this.setState(state)
  }

  show = event => {
    this.initialiseErrors(event)
    const state = this.state
    const offset =
      ReactDOM.findDOMNode(this.ref).getBoundingClientRect().bottom +
      ReactDOM.findDOMNode(this.ref).getBoundingClientRect().height

    if (
      offset >
      window.innerHeight - (ReactDOM.findDOMNode(this.ref).clientHeight + 200)
    ) {
      state.position = 'above'
    }
    state.show = true
    this.setState(state)
  }

  setValue = event => {
    const state = this.state

    state.date = event.target.value
    this.setState(state)
  }

  validateEntry = event => {
    const { i18n, preventFutureDates, dateSingleCallBack, handleDateChange } = this.props
    const errors = {}

    if (
      event.target.value !== null &&
      this.getMomentDate(event.target.value, true).isValid()
    ) {
      if (
        !(
          preventFutureDates &&
          this.getMomentDate(event.target.value).isAfter(moment())
        )
      ) {
        const state = this.state

        state.errors = errors
        this.setState(state)
      } else {
        const state = this.state

        errors.message = i18n.invalid_future_date
        state.errors = errors
        this.setState(state)
      }
    } else if (event.target.value.trim() !== '') {
      const state = this.state

      errors.message = i18n.invalid_date
      state.errors = errors
      this.setState(state)
    }

    if (!Object.keys(errors).length > 0) {
      if (dateSingleCallBack && window.TR_pageFunctions[dateSingleCallBack]) {
        window.TR_pageFunctions[dateSingleCallBack](event.target.value.toDate())
      }

      if (handleDateChange) {
        event.target.value.trim() !== ''
          ? handleDateChange(this.getMomentDate(event.target.value).toDate())
          : handleDateChange(null)
      }
    } else {
      this.setState({ errors })
      if (handleDateChange) {
        if (this.getMomentDate(event.target.value, true).isValid()) {
          handleDateChange(this.getMomentDate(event.target.value).toDate(), this.state.errors)
        } else {
          handleDateChange(event.target.value, this.state.errors)
        }
      }
    }
  }

  getMomentDate = (date, strictMode) => {
    const {
      dateFormat
    } = this.props

    if (strictMode) {
      return moment(
        date,
        dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY',
        true
      )
    }
      return moment(
        date,
        dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY'
      )

  }

  close = () => {
    const state = this.state

    state.show = false
    state.errors = {}
    this.setState(state)
  }

  positionCalendar() {
    if (this.state.position === 'above') {
      return {
        top: 'auto',
        bottom: '60px'
      }
    }

    return {}
  }

  handleClickOutsideDate = event => {
    if (this.ref && !ReactDOM.findDOMNode(this.ref).contains(event.target)) {
      if (this.state.show) {
        this.close()
      }
    }
  }

  handleKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      this.validateEntry(evt)
    }
  }

  dayRenderer = ({ date, handleClick, disabled }) => {
    const { dateFormat } = this.props
    const { date: selectedDate } = this.state

    const classNames = ['Day-inner']
    const dateFmt = date.format(
      dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY'
    )

    if (date && selectedDate === dateFmt) {
      classNames.push('from')
    }

    return (
      <button
        className={classNames.join(' ')}
        onClick={() => handleClick(date)}
        type='button'
        disabled={disabled}
      >
        {date.format('D')}
      </button>
    )
  }

  render() {
    const {
      dateFormat,
      datePickerName,
      i18n,
      label,
      locale,
      placeholder,
      preventFutureDates,
      optionalDescription,
      todayLink
    } = this.props
    const { date, fromDateClicked, show, errors } = this.state

    const calendarDate = date
      ? this.getMomentDate(date, true).isValid()
        ? date
        : moment().format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')
      : moment().format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')

    return (
      <DateRangeWrapper
        ref={ref => {
          this.ref = ref
        }}
      >
        {label && <DateRangeLabel>{label}</DateRangeLabel>}

        {optionalDescription && (
          <DateRangeDescription>{optionalDescription}</DateRangeDescription>
        )}

        <DateRangeOuter
          hideMarginTop={true}
          errorState={errors.message}
          active={show}
          data-testid='dateSingle'
        >
          <input
            type='text'
            name={datePickerName || 'DatePicker'}
            autoComplete='off'
            data-id='From'
            onChange={this.setValue}
            onBlur={this.validateEntry}
            onFocus={this.initialiseErrors}
            value={date}
            onKeyDown={this.handleKeyDown}
            placeholder={placeholder || 'Date'}
          />
          <div data-testid='dateSingleShowCalendar' onClick={this.show}>
            <Icon type='calendar' baseColor={'#afafaf'} />
          </div>
        </DateRangeOuter>

        {errors && <ErrorDivWrapper>{errors.message}</ErrorDivWrapper>}

        {show && (
          <DateRangeCalendar
            fromDateClicked={fromDateClicked}
            label={label}
            optionalDescription={optionalDescription}
            active={show}
            style={this.positionCalendar()}
            data-testid='dateSingleCalendar'
          >
            <TodayLink data-testid='TodayLink' className={'Day-inner'} onClick={this.selectToday}>
              {' '}
              {todayLink || 'Today'}
            </TodayLink>
            <Calendar
              date={this.getMomentDate(calendarDate)}
              onSelect={this.onSelect}
              locale={locale || 'en'}
              i18n={i18n}
              dayRenderer={this.dayRenderer}
              preventFutureDates={preventFutureDates}
            />
          </DateRangeCalendar>
        )}
      </DateRangeWrapper>
    )
  }
}
